import type { SvgIconProps } from "@mui/material/SvgIcon";
import SvgIcon from "@mui/material/SvgIcon";

type InterpolateIconProps = SvgIconProps;

const InterpolateIcon = ({ ...props }: InterpolateIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <circle cx="18" cy="6" r="3" stroke="none" fill="currentColor" />
        <path
          d="M 12 9 A 3 3 0 0 1 12 15 A 3 3 0 0 1 12 9 M 12 10 A 2 2 0 0 0 12 14 A 2 2 0 0 0 12 10"
          fill="currentColor"
          fillRule="evenodd"
        />
        <line x1="15.8787" y1="8.1213" x2="14.1213" y2="9.8787" stroke="currentColor" strokeWidth="1" />
        <line x1="9.8787" y1="14.113" x2="8.1213" y2="15.8787" stroke="currentColor" strokeWidth="1" />
        <circle cx="6" cy="18" r="3" stroke="none" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
};

export default InterpolateIcon;
